import { useEffect, useRef } from "react";

function WithStickyHeader({ children, className, style }) {
  const containerRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const container = containerRef.current;
      if (!container) return;

      const virtualScroller = container.querySelector(".MuiDataGrid-virtualScroller");
      const topContainer = container.querySelector(".MuiDataGrid-topContainer");

      if (!virtualScroller || !topContainer) return;

      const scrollerRect = virtualScroller.getBoundingClientRect();
      const windowTop = window.scrollY;
      const scrollerTop = scrollerRect.top + window.scrollY;
      const scrollerBottom = scrollerTop + scrollerRect.height;

      if (windowTop >= scrollerTop && windowTop <= scrollerBottom) {
        const difference = windowTop - scrollerTop;
        topContainer.style.top = `${difference}px`;
        topContainer.style.boxShadow = "0 4px 6px -6px rgba(0, 0, 0, 0.7)";
      } else {
        topContainer.style.top = "";
        topContainer.style.boxShadow = "none";
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      ref={containerRef}
      className={className}
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        flex: 1,
        ...style,
      }}
    >
      {children}
    </div>
  );
}

export default WithStickyHeader;
